import { FIND_IMAGES_API_URL, PRESIGN_URL } from "./bootstrap";
import $ from "jquery";
import moment from 'moment'
moment("Asia/Calcutta|Asia/Kolkata");

export const getDateTime = () => {
  return moment().format('ddd Do, MMM YYYY hh:mm:ss A')
}
export const getDate = () => {
  return moment().format('ddd D, MMM')
}
export const getTime = () => {
  return moment().format("h:mm A")
}
export const getResponse = (data) => {
  // Returns the jqXHR; callers attach .done()/.fail() and manage the loader.
  return $.ajax({
    async: true,
    url: FIND_IMAGES_API_URL,
    data: JSON.stringify(data),
    contentType: "application/json",
    dataType: "json",
    method: "post",
  });
}

// Downscale + JPEG-compress an image File before upload so face-match uploads stay
// small (fast on weak networks). Returns a new JPEG File; falls back to the
// original on any error. Applied centrally so camera, file-picker and dropzone
// all compress the same way.
export const compressImage = (file, maxDim = 1280, quality = 0.8) =>
  new Promise((resolve) => {
    try {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        try {
          let { width, height } = img;
          if (width > height && width > maxDim) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else if (height >= width && height > maxDim) {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            (blob) => {
              URL.revokeObjectURL(url);
              if (!blob) { resolve(file); return; }
              const base = file.name ? file.name.replace(/\.[^.]+$/, "") : "photo";
              resolve(new File([blob], base + ".jpg", { type: "image/jpeg" }));
            },
            "image/jpeg",
            quality
          );
        } catch (e) {
          URL.revokeObjectURL(url);
          resolve(file);
        }
      };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    } catch (e) {
      resolve(file);
    }
  });

// Presigned-URL upload: (0) compress, (1) get a presigned URL, (2) PUT the file
// straight to S3. Returns the server-generated key (passed to find-faces).
// Presign endpoint: POST { filename, filetype } -> { uploadUrl, key }.
export const uploadViaPresignedUrl = async (file) => {
  // Compress before upload (all cases: camera, file-picker, dropzone).
  file = await compressImage(file);
  // Compressed output is always image/jpeg — used for both the presign request
  // and the PUT so S3's signed content-type matches (avoids SignatureDoesNotMatch).
  const contentType = file.type || "image/jpeg";
  const ext = contentType.split("/")[1] || "jpg";
  const filename = file.name || `photo.${ext}`;

  // Step labels so a failure alert says WHICH step broke (presign vs S3 PUT).
  // GET with query params (a simple request — no CORS preflight).
  let res;
  try {
    const params = new URLSearchParams({ filename, filetype: contentType });
    res = await fetch(`${PRESIGN_URL}?${params}`).then((r) => r.json());
  } catch (e) {
    throw new Error("[presign] " + e.message);
  }

  const info = (res && res.response) || res || {};
  const uploadUrl = info.uploadUrl || info.url;
  const key = info.key;
  if (!uploadUrl) throw new Error("[presign] no url in response");

  // PUT the file straight to S3 (Content-Type is part of the signed request).
  let put;
  try {
    put = await fetch(uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": contentType },
      body: file,
    });
  } catch (e) {
    throw new Error("[s3-put] " + e.message);
  }
  if (!put.ok) throw new Error("[s3-put] status " + put.status);

  return key;
}

export const dayList = () => {
  let results = [];
  for (let i = 1; i <= 31; i++) {
    let res = i <= 9 ? `0${i}` : i;
    let data = {
      "value": res,
      "label": res
    }
    results.push(data);
  }
  return results;
};

export const yearsList = () => {
  let results = [];
  for (let i = 1920; i <= 2002; i++) {
    let data = {
      "value": i,
      "label": i
    }
    results.push(data);
  }
  return results;
};


export const filesize = (url, callback) => {
  var xhr = new XMLHttpRequest();
  xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
  //  to get only the header
  xhr.onreadystatechange = function () {
    if (this.readyState == this.DONE) {
      callback(parseInt(xhr.getResponseHeader("Content-Length")));
    }
  };
  xhr.send();
}

export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};

export const onShareClick = function (sharemode = "", postid = "", url = "") {
  var payload = {
    url,
    article_id: postid,
    sharetype: sharemode,
    platform: getDeviceType() == "mobile" ? "pwa" : "desktop",
  };
  // APICall("appuser/SaveShareInfo", payload);
  // APICall("article/addsharecount?id=" + postid, {
  //   method: "GET",
  // });
};

export const dataURLToBlob = function (dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;

}

export const getDeviceType = () => {
  try {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
  } catch (er) {
    return "desktop";
  }
  return "desktop";
};
